import React from 'react';
import { styled } from '@nykaa/ui-components';
import CheckBox from '../Filters/Facets/Shared/CheckBox';


const SortOption = styled.ul`
  position: relative;
  list-style: none;
  width: 100%;
  display: block;
`;
interface SortListProps {
  sortOptions: { key: string; name: string }[];
  activeSort: string;
  onSelect: (e: { [key: string]: string }) => void;
}

const SortList = ({ sortOptions, activeSort, onSelect }: SortListProps) => (
  <SortOption>
    {sortOptions.map(sortOption => {
      const { key } = sortOption;
      const isChecked = activeSort === sortOption.key;
      return (
        <CheckBox
          type="radio"
          key={`radio_${key}`}
          data={sortOption}
          isSelected={isChecked}
          handleFilterChange={onSelect}
        />
      );
    })}
  </SortOption>
);

export default SortList;
